// ============================================================================
// view.addfeed — authenticated lookup ownership
// ============================================================================
// The Add Feed presenter receives its two lookup bundles through an app-side
// authenticated resource bridge. This localizes the seven form reads without
// changing the existing App boot gate or the offline RPC submit lifecycle; it
// is permanent read ownership only, not a boot-independence declaration.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.addfeed',
  obligations: Object.freeze([
    Object.freeze({id: 'webform.addfeed.inputs', owner: 'permanent'}),
    Object.freeze({id: 'webform.addfeed.config', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
